/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */

import { Consts } from '@dm/core';

/**
 * 虚拟机系统盘最小容量(10GB->扇区)
 */
export const VIRTUAL_MACHINE_SYSTEM_DISK_MIN_CAPACITY = 10 * 1024 * 1024 * 2;

/**
 * 虚拟机系统盘最大容量(1T->扇区)
 */
export const VIRTUAL_MACHINE_SYSTEM_DISK_MAX_CAPACITY = 1000 * 1024 * 1024 * 2;

/**
 * 表格最少需要选择项
 */
export const MIN_SELECTION = 1;

/**
 * 创建虚拟机超时时间 （底层超时时间10分钟，前端多10s）
 */
export const CREATE_VM_TIMEOUT = 610000;

/**
 * 系统盘容量默认单位
 */
export const DEFAULT_CAPACITY_UNIT = Consts.GB;

/**
 * 虚拟机名称最小长度
 */
export const VIRTUAL_MACHINE_NAME_MIN_LENGTH = 1;

/**
 * 虚拟机名称最大长度
 */
export const VIRTUAL_MACHINE_NAME_MAX_LENGTH = 53;
